import React, { useState } from 'react';

import { SelectWrapper } from './style';

interface ISelectProps {
  // value: string | number | readonly string[] | undefined;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onFocus?: () => void;
  id?: string;
  label: string;
  alert?: string;
  hasError?: boolean;
  errorMessage?: React.ReactNode;
}

const Select: React.FC<ISelectProps> = ({
  children,
  onChange,
  id,
  onFocus,
  label,
  alert,
  hasError,
  errorMessage,
}) => {
  return (
    <>
      <SelectWrapper>
        <label htmlFor={id}>{label}</label>
        {alert ? <span className="alert">{alert}</span> : null}
        <select
          id={id}
          className={hasError ? 'error-border' : ''}
          onChange={onChange}
          onFocus={onFocus}
        >
          {children}
        </select>
        {errorMessage}
      </SelectWrapper>
    </>
  );
};

export default Select;
